export const getBenefitsData = (
  t: (key: string) => string,
  srcImgs: string
) => [
  {
    img: `${srcImgs}benefits-fire.webp`,
    alt: 'benefits.1',
    text: t('offerCard.benefits.first'),
  },
  {
    img: `${srcImgs}benefits-headphones.webp`,
    alt: 'benefits.2',
    text: t('offerCard.benefits.second'),
  },
];

export interface OfferCardConfig {
  height: {
    desktop: number;
    mobile: number;
  };
  text: {
    color: string;
  };
  background: {
    color: string;
  };
  border: {
    color: string;
  };
  regButton: {
    color: string;
    borderRadius: string;
  };
  cards: {
    bg: string;
  };
  withCards?: boolean;
}

export const OFFER_CARD_THEME_DEFAULT: OfferCardConfig = {
  height: {
    desktop: 460,
    mobile: 380,
  },
  text: {
    color: `linear-gradient(
      180deg,
      #ffffff 0%,
      #fffe2a 25%,
      #ff9b00 50%,
      #fffe2a 75%,
      #ffffff 100%
    )`,
  },
  background: {
    color: 'linear-gradient(351deg, #632668 16.46%, #6880cc 108.4%)',
  },
  border: {
    color: '#FFAD01',
  },
  regButton: {
    color: 'yellow',
    borderRadius: '8px',
  },
  cards: {
    bg: 'transparent',
  },
  withCards: false,
};

export const OFFER_CARD_THEME_BLUE: OfferCardConfig = {
  height: {
    desktop: 525,
    mobile: 434,
  },
  text: {
    color: '#ffffff',
  },
  background: {
    color: 'linear-gradient(351deg, #173A75 16.46%, #2E7FAE 108.4%);',
  },
  border: {
    color: 'rgba(255, 255, 255, 0.50)',
  },
  regButton: {
    color: 'green',
    borderRadius: '8px',
  },
  cards: {
    bg: 'transparent',
  },
  withCards: true,
};

export const OFFER_CARD_THEME_RED: OfferCardConfig = {
  height: {
    desktop: 460,
    mobile: 458,
  },
  text: {
    color: `linear-gradient(
      180deg,
      #FFAD01 0%,
      #FFD500 40%,
      #FFD500 60%,
      #FFAD01 100%
    )`,
  },
  background: {
    color: 'linear-gradient(180deg, #cf321a 0%, #3f0000 100%)',
  },
  border: {
    color: '#FFAD01',
  },
  regButton: {
    color: 'orange',
    borderRadius: '8px',
  },
  cards: {
    bg: 'transparent',
  },
  withCards: true,
};

export const OFFER_CARD_THEME_GREEN: OfferCardConfig = {
  height: {
    desktop: 460,
    mobile: 383,
  },
  text: {
    color: '#FFFFFF',
  },
  background: {
    color: 'linear-gradient(180deg, #009D32 0%, #013C13 100%)',
  },
  border: {
    color: 'rgba(255,255,255,.5)',
  },
  regButton: {
    color: 'green',
    borderRadius: '12px',
  },
  cards: {
    bg: 'transparent',
  },
  withCards: true,
};

export const OFFER_CARD_THEME_PINK: OfferCardConfig = {
  height: {
    desktop: 460,
    mobile: 380,
  },
  text: {
    color: '#FF74AF',
  },
  background: {
    color: 'linear-gradient(180deg, #CA197E 0%, #8A0233 100%)',
  },
  border: {
    color: 'rgba(255,255,255,.5)',
  },
  regButton: {
    color: 'green',
    borderRadius: '12px',
  },
  cards: {
    bg: 'transparent',
  },
  withCards: true,
};

export const OFFER_CARD_THEME_VIOLET: OfferCardConfig = {
  height: {
    desktop: 460,
    mobile: 380,
  },
  text: {
    color: '#FFFFFF',
  },
  background: {
    color: 'linear-gradient(180deg, #6868CC 0%, #782480 100%)',
  },
  border: {
    color: '#FFAD01',
  },
  regButton: {
    color: 'green',
    borderRadius: '12px',
  },
  cards: {
    bg: 'transparent',
  },
  withCards: true,
};

export const OFFER_CARD_THEME_DARK_VIOLET: OfferCardConfig = {
  height: {
    desktop: 460,
    mobile: 380,
  },
  text: {
    color: '#FFFFFF',
  },
  background: {
    color: 'linear-gradient(347deg, #2F0A5B 0.89%, #8C0EE8 76.81%)',
  },
  border: {
    color: '#FFAD01',
  },
  regButton: {
    color: 'green',
    borderRadius: '12px',
  },
  cards: {
    bg: 'transparent',
  },
  withCards: true,
};

export const offerCardThemes: Record<string, OfferCardConfig> = {
  default: OFFER_CARD_THEME_DEFAULT,
  blue: OFFER_CARD_THEME_BLUE,
  red: OFFER_CARD_THEME_RED,
  green: OFFER_CARD_THEME_GREEN,
  pink: OFFER_CARD_THEME_PINK,
  violet: OFFER_CARD_THEME_VIOLET,
  darkViolet: OFFER_CARD_THEME_DARK_VIOLET,
};

export const getTheme = (cardTheme?: OfferCardConfig, themeName?: string) =>
  cardTheme || offerCardThemes[themeName ?? ''] || offerCardThemes.default;

export const getButtonConfig = () => ({
  yellow: { yellow: true },
  green: { green: true },
  secondaryGreenGradient: { secondaryGreenGradient: true },
  sandGold: { sandGold: true },
  orange: { orange: true },
});

export const coinConfig = {
  'coins-1': { width: 78, height: 49 },
  'coins-2': { width: 72, height: 45 },
  'coins-3': { width: 51, height: 31 },
} as const;
